export default "__VITE_ASSET__C8FpIa_7__"